<template>
    <div class="slide trivia-6">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="3"
                    :total="3"
                    :className="className"
                    :selectAll=true />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "yarnboard-2",
            className: "trivia-6",
            currentTrivia: 6,
            questions: {
                question: {
                    "title": "What pieces of information are desired to issue a BOLO?",
                    "answers": [
                        {"key": "A", "answer": "Subject's name"},
                        {"key": "B", "answer": "A picture of the subject"},
                        {"key": "C", "answer": "Summary of their actions including the method of their operation"},
                        {"key": "D", "answer": "Vehicle description"}
                    ],
                    "correctAnswer": ["A", "B", "C", "D" ]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-6 {

    h1 {
        font-size: 26px !important;
    }
}
</style>
